'use strict';

const _ = require('underscore'),
	Poller = require('./poller');
module.exports = function S3Api(navigatorShim, ajaxPromise, s3ApiOptions) {
	const self = this,
		saveFailed = function (evt) {
			const errorReasonMap = { 'EntityTooLarge': 'file-too-large' };
			try {
				const errorReason = navigatorShim.buildAjaxXMLResponse(evt).valueOf('Error Code');
				return errorReasonMap[errorReason] || 'network-error';
			} catch (e) {
				return 'network-error';
			}
		};

	self.save = (contentToSave, saveConfiguration, options) => {
		const formData = navigatorShim.buildFormData();
		Object.keys(saveConfiguration.fields).filter(key => key !== 'key').forEach((key) => formData.append(key, saveConfiguration.fields[key]));
		formData.append('key', saveConfiguration.key);
		formData.append('file', contentToSave);
		return ajaxPromise.upload(saveConfiguration.url, formData, options && options.notify)
		.catch(reason => {
			if (reason && reason.status === 403) {
				throw 'failed-authentication';
			}
			if (reason && reason.responseText) {
				throw saveFailed(reason.responseText);
			}
			if (reason && reason.statusText) {
				throw reason.statusText;
			}
			throw 'network-error';
		});
	};

	self.poll = function (signedListUrl, callOptions) {
		const startTS = Date.now(),
			pollOptions = {
				timeout: callOptions && callOptions.sleepPeriod,
				cache: 'no-store'
			},
			shouldStop = function () {
				return (callOptions.stoppedSemaphore && callOptions.stoppedSemaphore());
			},
			pollAction = async () => {
				const response = await ajaxPromise.get(signedListUrl, pollOptions);
				return navigatorShim.buildAjaxXMLResponse(response).valueOf('Contents Key');
			},
			hasTimedOut = function () {
				return (startTS + callOptions.timeoutPeriod) < Date.now();
			},
			pollingFailurePredicate = function () {
				return hasTimedOut() || shouldStop();
			},
			poller = (s3ApiOptions && s3ApiOptions.poller) || new Poller(navigatorShim);
		callOptions = _.extend({sleepPeriod: 1000, timeoutPeriod: 120000}, callOptions);
		return poller.poll(pollAction, x => x, {
			pollingInterval: callOptions.sleepPeriod,
			pollingFailurePredicate: pollingFailurePredicate
		});
	};
	self.loadUrl = async (url, callOptions) => {
		const params = Object.assign({
				cache: 'no-store'
			}, callOptions),
			errorTransformer = (err) => {
				if (err.status === 404 || err.status === 403) {
					return 'not-found';
				} else if (callOptions && callOptions.range && err.status === 416) {
					return 'end-of-file';
				} else {
					return 'network-error';
				}
			};
		if (callOptions && callOptions.range) {
			params.headers =  {
				Range: 'bytes=' + callOptions.range.startByte + '-'
			};
		}

		try {
			return await ajaxPromise.get(url, params);
		} catch (e) {
			throw errorTransformer(e);
		}
	};
};
